import styled from "styled-components";
import { useState, useEffect } from "react";
import Breakpoints from "../../config/Breakpoints";
import RaffleTab from "./raffleTab";
import SectionTitle from "./sectionTitle";
import DateFormatUtil from "../../helpers/DateFormatUtil";
import DocumentNumberMaskUtil from "../../helpers/DocumentMaskUtil";
import LuckyNumberFormatUtil from "../../helpers/LuckyNumberFormatUtil";

const WinnersBlock = styled.div`
    margin: 2.5rem auto 0;
    border-radius: .5rem;
    border: 1px solid var(--color-lightGray);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.10);
    background: var(--color-white);
    padding: 1rem 1.25rem;
    max-width: 55rem;
    min-height: 15rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .emptyMessage {
        display: flex;
        flex-direction: column;
        gap: .5rem;
        text-align: center;

        span {
            color: var(--color-gray);
        }

        strong {
            font-size: var(--font-size-lg);
            font-weight: var(--font-weight-semibold);
        }
    }

    table {
        width: 100%;
        text-align: center;


        th {
            color: var(--color-gray);
            font-size: var(--font-size-xs);
            text-transform: uppercase;
            
        }

        th, td {
            padding: .5rem .25rem;
            white-space: nowrap;
        }

        td {
            border-top: 1px solid var(--color-xLightGray);
        }
    }

    @media ${Breakpoints.max.sm} {
        min-height: 10rem;
    }

    @media ${Breakpoints.max.xs} {
        overflow-x: auto;

        table {
            width: fit-content;

            th, td {
                padding: .5rem 1rem;
                white-space: nowrap;
            }
        }
    }
`

const Winners = ({sectionData, promoData}) => {
    const [currentWinnersData, setCurrentWinnersData] = useState([]);
    const [currentWinnersAvailability, setCurrentWinnersAvailability] = useState(null);
    const [showWinners, setShowWinners] = useState(false);
    
    useEffect(() => {
        promoData.raffles.forEach((item) => {
            if(item.isNextRaffle) {
                setWinnerData(item);
                return;
            }
        });
    },[promoData]);

    useEffect(() => {
        setShowWinners(showWinnersCheck());
    },[currentWinnersData, currentWinnersAvailability]);

    const showWinnersCheck = () => {
        let rtn = false;
        if(
            currentWinnersAvailability === null &&
            currentWinnersData.length > 0
        ) {
            rtn = true;
        } else if(currentWinnersData.length === 0) {
            rtn = false;
        } else {
            let today = new Date();
            let showWinnerDate = new Date(`${currentWinnersAvailability}T00:00:00`);

            rtn = today >= showWinnerDate;
        }
        console.log('showWinnersCheck',rtn,currentWinnersAvailability,currentWinnersData);
        return rtn;
    }

    const getRaffleWinners = (rafflePrizes) => {
        let rtn = [];
        rafflePrizes.forEach((item) => {
            let currentPrizeName = item.name;

            item.winners.forEach((winner) => {
                rtn.push({...winner, prize: currentPrizeName});
            });
        });
        console.log('getRaffleWinners',rtn);
        return rtn;
    }

    const setWinnerData = (raffleData) => {
        setCurrentWinnersData(getRaffleWinners(raffleData.rafflePrizes));
        setCurrentWinnersAvailability(raffleData.winnersPublishDate || null);
    }

    const setCurrentTab = (newValue) => {
        setWinnerData(promoData.raffles[newValue]);
    };

    return (
        <>
            <SectionTitle>{sectionData.title}</SectionTitle>
            <div>
                <RaffleTab promoData={promoData} handleChange={setCurrentTab} />
                <WinnersBlock>
                    {!showWinners && (
                        <div className="emptyMessage">
                            <strong>Aguarde!</strong>
                            <span>
                                A divulgação dos ganhadores será realizada&#160;
                                {currentWinnersAvailability !== null && <>a partir de {DateFormatUtil(currentWinnersAvailability)}</>}
                                {currentWinnersAvailability === null && <>em breve</>}
                            </span>
                        </div>
                    )}
                    {showWinners && (
                        <table>
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>CPF/CNPJ</th>
                                    <th>Prêmio</th>
                                    <th>Nº da sorte</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentWinnersData.map((item, index) => (
                                    <tr key={`winnerNumber_${item.luckyNumber || ''}_${item.documentNumber || ''}`}>
                                        <td>{item.memberName || ''}</td>
                                        <td>{DocumentNumberMaskUtil(item.documentNumber) || ''}</td>
                                        <td>{item.prize}</td>
                                        <td>{LuckyNumberFormatUtil(item.luckyNumber || '')}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </WinnersBlock>
            </div>
        </>
    );
}

export const WinnersStyles = `
    
`;

export default Winners;